import style from './EntryVersion.module.scss';

import { RightContentMenu } from '../RightContentMenu';
// import { EntryVersionList } from './EntryVersionList';
import { FieldVersionList } from './FieldVersionList';

export interface EntryVersionProps {}

interface Props extends EntryVersionProps {
    isAllEntrySelected: boolean;
    menuHeight: number;
    menuRef: React.RefObject<HTMLDivElement | null>;
}

export function EntryVersion({ isAllEntrySelected, menuRef, menuHeight }: Props) {
    return (
        <div className={style.root}>
            <div
                className={style.menu}
                ref={menuRef}
            >
                <RightContentMenu />
            </div>
            {/*<div className={style.versionList}>{isAllEntrySelected ? <EntryVersionList /> : <FieldVersionList />}</div>*/}
            <div className={style.versionList}>
                <FieldVersionList />
            </div>
        </div>
    );
}
